// extracted by mini-css-extract-plugin
export default {"icon":"LoadingButton_icon__3zSKH","rotation":"LoadingButton_rotation__I4nk2"};